import { combineReducers } from 'redux';
import entityReducer from './entityReducer';
import attributeReducer from './attributeReducer';

export default combineReducers({
    entityReducer,
    attributeReducer,
});
